
import { locationAssignmentAxiosInstance } from 'utils/location-assignment.axios.instance'
import { type ProductWithLocations } from './location-assignment.types'

export async function getLocationAssignedToProduct (ean): Promise<ProductWithLocations> {
  return await locationAssignmentAxiosInstance()
    .get<ProductWithLocations>(`/assignments/${ean}`)
    .then(({ data }) => data)
}